import Styles from "./Pdd.module.css";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import {
  Divider,
  FormControl,
  IconButton,
  Input,
  InputAdornment,
  InputLabel,
  List,
  ListItem,
  useAutocomplete,
} from "@mui/material";
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";

export default function ThemeList({ themeData }) {
  const [themes, setThemes] = useState([]);
  const [params, setParams] = useSearchParams();
  const {
    getRootProps,
    getInputLabelProps,
    getInputProps,
    getListboxProps,
    getOptionProps,
    groupedOptions,
  } = useAutocomplete({
    id: "use-autocomplete-demo",
    options: themeData.map((item) => {
      return {
        label: item.theme_number + ". " + item.name,
        id: item.id,
      };
    }),
    getOptionLabel: (option) => option.label,
  });

  useEffect(() => {
    // console.log("Изменение фильтра");
    const inputProps = getInputProps();

    if (groupedOptions.length === 0 || !inputProps.value) {
      // console.log(themeData);
      return setThemes(themeData);
    }
    const userQuerry =
      groupedOptions &&
      groupedOptions.map((filtredTheme) => {
        return themeData.find((masterTheme) => {
          return filtredTheme.id == masterTheme.id;
        });
      });

    setThemes(userQuerry);
  }, [groupedOptions.length]);

  // console.log(groupedOptions.length);

  const handleThemeClick = (e) => {
    const themeId = e.target.id;
    const themeName = e.target.innerHTML;
    e.target.scrollIntoView({
      behavior: "smooth",
      block: "center",
      inline: "center",
    });
    setParams({ theme: themeId, name: themeName });
  };

  return (
    <>
      <div className={Styles.pdd_heading}>
        <h6 style={{ borderBottom: "2px solid var(--bckg-baze)" }}>
          Темы ПДД ПМР
        </h6>

        <TextField
          sx={{ padding: "0 15px" }}
          {...getInputProps()}
          size="small"
          placeholder="Поиск темы"
          id="filterField"
          onBlur={(e) => {
            e.preventDefault();
          }}
          // slotProps={{
          //   input: {
          //     endAdornment: (
          //       <InputAdornment position="end">
          //         <IconButton
          //           onClick={(e) => {
          //             console.log("delete");
          //             const inputProps = getInputProps();

          //             inputProps.value = "";
          //           }}
          //           // onMouseDown={(e) => e.preventDefault}
          //           // onMouseUp={(e) => e.preventDefault}
          //         >
          //           <CloseRoundedIcon />
          //         </IconButton>
          //       </InputAdornment>
          //     ),
          //   },
          // }}

          // onBlur={(e) => {
          //   setThemes(themeData);
          // }}
        />
      </div>
      <Divider style={{ width: "100%" }} />
      <List sx={{ height: "100%", overflowY: "scroll", margin: "15px" }}>
        {themes.map((theme) => (
          <>
            <ListItem
              sx={{ paddingLeft: " 0", paddingRight: "0" }}
              className={Styles.theme_item}>
              <ListItem id={theme.id} onClick={handleThemeClick}>
                {theme.theme_number + ". " + theme.name}
              </ListItem>
            </ListItem>
            <Divider />
          </>
        ))}
      </List>
    </>
  );
}
